import { TermsCopy } from '@components/ui';
import Typography from '@mui/material/Typography';
export function AcceptanceSection(): JSX.Element {
  return (
    <>
      <Typography component="p" sx={{ textTransform: 'uppercase', fontWeight: 700, fontSize: 20, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.acceptance.0" />
      </Typography>
      <Typography component="p" sx={{ fontSize: 14, color: 'text.primary' }}>
        <TermsCopy i18nKey="termsSections.acceptance.1" />
      </Typography>
    </>
  );
}
